import { ReactComponent as PS1Logo } from '../assets/logos/playstation.svg';
import { ReactComponent as PS2Logo } from '../assets/logos/playstation2.svg';
import { ReactComponent as PS3Logo } from '../assets/logos/playstation3.svg';
import { ReactComponent as PS4Logo } from '../assets/logos/playstation4.svg';
import { ReactComponent as PS5Logo } from '../assets/logos/playstation5.svg';

export const getPlatformLogo = (platform: string) => {
  switch (platform) {
    case 'PS1':
      return PS1Logo;
    case 'PS2':
      return PS2Logo;
    case 'PS3':
      return PS3Logo;
    case 'PS4':
      return PS4Logo;
    case 'PS5':
      return PS5Logo;
    default:
      return null;
  }
};